import { CommunicationsWrapper } from "./communications.style";
import { CommunicationsSection } from "./sections/communications.section";

export const CommunicationsPage = () => <CommunicationsWrapper><CommunicationsSection /></CommunicationsWrapper>;
